export default __webpack_public_path__ + "static/media/coming-soon.46211072.png";